import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function StockRecoReq() {
  const [data, setData] = useState([]);
  const [remarks, setRemarks] = useState({});

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };



  // Fetch red process data
  const fetchStockRecoReq = useCallback(async () => {
    try {
      const response = await axiosInstance.get("api/get-StockChange-request");
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching Red Process data:", error);
    }
  }, []);

const fetchStockChangeRemarks = useCallback(async () => {
  try {
    const response = await axiosInstance.get("/api/get-StockChange-request");

    // Create a lookup of remarks using ID as the key
    const remarksMap = {};
    response.data.forEach(item => {
      remarksMap[item.ID] = item.remark2 || "";
    });

    setRemarks(remarksMap);
  } catch (error) {
    console.error("❌ Error fetching remarks:", error);
    showAlert("Failed to fetch remarks", "danger");
  }
}, []);


  useEffect(() => {
    fetchStockRecoReq();
    fetchStockChangeRemarks();
  }, [fetchStockRecoReq, fetchStockChangeRemarks]);


 const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };
// Update remarks with debounce
  const handleRemarksBlur = (id, value) => {
    const trimmed = value.trim() || null;
    if (trimmed === data.find(r => r.id === id)?.remark2) return;
    clearTimeout(window.remarkTimeout);
    window.remarkTimeout = setTimeout(async () => {
      try {
        await axiosInstance.patch(`/api/update-remark2/${id}`, { remark2: trimmed });
        showAlert("Remark updated", "success");
        fetchStockRecoReq();
      } catch (err) {
        console.error("remark2 update error:", err);
        showAlert("Record Not Send.", "danger");
      }
    }, 800);
  };
  
const handleApprove = async (id) => {
  try {
    // Optional: Show "Approving..." status in UI
    setData((prev) =>
      prev.map((r) =>
        r.ID === id ? { ...r, request_status: "Approving..." } : r
      )
    );

    // Call the PATCH API
    await axiosInstance.patch("/api/update-request-status", {
      ID: id,
      request_status: "Approved"
    });

    // Update UI to reflect success
    setData((prev) =>
      prev.map((r) =>
        r.ID === id ? { ...r, request_status: "Approved" } : r
      )
    );

    showAlert("✅ Approved successfully.", "success");
  } catch (err) {
    console.error("❌ Failed to approve request:", err);
    showAlert("❌ Approval failed.", "danger");

    // Optional: Revert status
    fetchStockRecoReq(); // Refresh the data
  }
};

const handleReject = async (id) => {
  try {
    // Optional: Show "Approving..." status in UI
    setData((prev) =>
      prev.map((r) =>
        r.ID === id ? { ...r, request_status: "Rejecting..." } : r
      )
    );

    // Call the PATCH API
    await axiosInstance.patch("/api/update-request-status", {
      ID: id,
      request_status: "Rejected"
    });

    // Update UI to reflect success
    setData((prev) =>
      prev.map((r) =>
        r.ID === id ? { ...r, request_status: "Rejected" } : r
      )
    );

    showAlert("Rejected successfully.", "success");
  } catch (err) {
    console.error("❌ Failed to approve request:", err);
    showAlert("❌ Rejected failed.", "danger");

    // Optional: Revert status
    fetchStockRecoReq(); // Refresh the data
  }
};
  // Columns for DataTable
  const columns = [
    {
      name: "Lot ID",width: "180px",
      selector: (row) => row.LotID,
      sortable: true, 
    },
    {
      name: "RMItemCode", width:"180px",
      selector: (row) => row.RMItemCode,
      sortable: true,
    },
    {
      name: "AllocateQty",
      selector: (row) => row.AllocateQty,
      sortable: true,
    },
 {
      name: "Quantity Consumed",
      selector: (row) => row.quantity_consumed || "N/A",
      sortable: true,
    },
        {
      name: "Quantity_rec_back",
      selector: (row) => row.quantity_rec_back || "N/A",
      sortable: true,
    },
    {
    name: "Qty Diff",
    selector: (row) => row.QtyDiff,
    sortable: true,
    cell: (row) => {
    const qty = row.QtyDiff;

    // If null or undefined, show as blank or "N/A" without background
    if (qty === null || qty === undefined) {
      return <div style={{ textAlign: "center", color: "#999" }}>—</div>;
    }

    const isZero = parseFloat(qty) === 0;

      return (
        <div
          style={{
            backgroundColor: isZero ? "#d4edda" : "#dc3545",
            color: isZero ? "#155724" : "#ffffff",
            padding: "8px 13px",
            borderRadius: "5px",
            textAlign: "center",
            fontWeight: "bold",
            minWidth: "60px"
          }}
        >
          {qty}
        </div>
      );
    },
  },
    {
      name: "Request Date",
      selector: (row) => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.requestDate}
        >
            {row.requestDate}
        </span>
      ) ,
      sortable: true,
    },
    {
      name: "Remark",
      selector: (row) =>(
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.remark1}
         style={{ cursor: "help" }}
        >
             {row.remark1}
        </span>
      ) ,
      sortable: true,
    },
   {
      name: "Add Remarks",width:"170px",
      cell: row => (
        <textarea
          className="form-control"
          rows={1}
          style={{ fontSize: '12px', width: '150px' }}
          // value={remarks[row.id] || ''}
          value={
            remarks[row.ID] !== undefined
              ? remarks[row.ID]
              : row.remark2 || ""
          }
          onChange={e => setRemarks(prev => ({ ...prev, [row.ID]: e.target.value }))}
          onBlur={e => handleRemarksBlur(row.ID, e.target.value)}
          placeholder="Enter Remark"
        />
      ),
      sortable: true
    },
    //   {
    //   name: "Action",
    //   cell: (row) => {
    //     if (row.request_status === "Approved") {
    //       return (
    //         <span style={{ color: "green", fontWeight: "bold" }}>
    //           Approved
    //         </span>
    //       );
    //     } else if (row.request_status === "Approving...") {
    //       return (
    //         <button className="btn btn-sm btn-secondary" disabled>
    //           Approving…
    //         </button>
    //       );
    //     } else {
    //       return (
    //         <button
    //           className="btn btn-sm btn-primary"
    //           onClick={() => handleApprove(row.ID)}
    //         >
    //           Approve
    //         </button>
    //       );
    //     }
    //   },
    //   ignoreRowClick: true, // so clicking the button doesn’t select the row
    //   allowOverflow: true,
    //   button: true,
    // },

    {
  name: "Action",
  cell: (row) => {
    const status = row.request_status;

    if (status === "Approved") {
      return (
        <span style={{ color: "green", fontWeight: "bold" }}>
          Approved
        </span>
      );
    } else if (status === "Rejected") {
      return (
        <span style={{ color: "red", fontWeight: "bold" }}>
          Rejected
        </span>
      );
    } else if (status === "Approving..." || status === "Rejecting...") {
      return (
        <button className="btn btn-sm btn-secondary" disabled>
          {status}
        </button>
      );
    } else {
      return (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-success"
            onClick={() => handleApprove(row.ID)}
          >
            ✅
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => handleReject(row.ID)}
          >
            ❌
          </button>
        </div>
      );
    }
  },
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}

  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div className="mt-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-5">Stock Reco Request</h3>
            </div>
            <DataTable
              columns={columns}
              data={data}
              pagination
              highlightOnHover
              // striped
              persistTableHead
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default StockRecoReq;
